import React from 'react';
import classNames from 'classnames';
import { SectionSplitProps } from '../../utils/SectionProps';
import SectionHeader from './partials/SectionHeader';

const propTypes = {
  ...SectionSplitProps.types
}

const defaultProps = {
  ...SectionSplitProps.defaults
}

const ContactForm = ({
  className,
  topOuterDivider,
  bottomOuterDivider,
  topDivider,
  bottomDivider,
  hasBgColor,
  invertColor,
  invertMobile,
  invertDesktop,
  alignTop,
  imageFill,
  ...props
}) => {

  const outerClasses = classNames(
    'features-split section',
    topOuterDivider && 'has-top-divider',
    bottomOuterDivider && 'has-bottom-divider',
    hasBgColor && 'has-bg-color',
    invertColor && 'invert-color',
    className
  );

  const innerClasses = classNames(
    'features-split-inner section-inner',
    topDivider && 'has-top-divider',
    bottomDivider && 'has-bottom-divider'
  );

  const splitClasses = classNames(
    'split-wrap',
    invertMobile && 'invert-mobile',
    invertDesktop && 'invert-desktop',
    alignTop && 'align-top'
  );

  const sectionHeader = {
    title: 'Contact Us',
    paragraph: 'Submit the Form Below to get in contact with us.'
  };
  function submitButton(e)
  {
    e.preventDefault();
    let sendername = document.querySelector("#sendername");
    let email = document.querySelector("#email");
    let message = document.querySelector("#message");
    console.log(sendername.value, email.value, message.value)
    var xhr = new XMLHttpRequest();
    xhr.open("POST", "https://zbbr7ab94j.execute-api.us-east-1.amazonaws.com/dev", true);

    xhr.setRequestHeader("Content-type", "application/json");
    xhr.onreadystatechange = function() {
      if (xhr.readyState == XMLHttpRequest.DONE && xhr.status == 200) {
      }
    };
    var data = {
      name: sendername.value,
      email: email.value,
      message: sendername.value +" said " + message.value
    };


    let success = document.querySelector("#success");
    let error = document.querySelector("#error");

    if (sendername.value && email.value && message.value) {
      success.style.display = "block";
      success.innerHTML = "Thanks for submitting";
      sendername.style.display = "none";
      email.style.display = "none";
      message.style.display = "none";
      xhr.send(JSON.stringify(data));

    } else {
        error.style.display = "block";
        error.innerHTML = "Please Fill  All Details";
    }




    // alert('Not Yet Available, please email: spourshalchi {at} gmail.com');

  }
  //   function onInputChange(name)
  // {
  //   alert('Not Yet Available ');
  //   // alert('Thanks for Subscribing');
  // }


  return (
    <section
      {...props}
      className={outerClasses}
    >
      <div className="container">
        <div className={innerClasses}>
          <SectionHeader data={sectionHeader} className="center-content" />
          <div className={splitClasses}>

            <div className="split-item">
              <div className="split-item-content center-content-mobile reveal-from-left" data-reveal-container=".split-item">
                <div className="text-xxs text-color-primary fw-600 tt-u mb-8">
                  Contact Form
                  </div>

              <label>Enter Name: </label><input type="text" style={{color: "green", borderRadius: "5px"}}
               name="name"
               id="sendername" />

              <p></p>
              <label>Enter Email: </label><input type="email" style={{color: "green", borderRadius: "5px"}}
               name="email"
               id="email" />


              <p></p><label>Enter Message: </label><input type="textarea" placeholder="Enter your message/inquiry *" style={{color: "green", width: "600px", height: "120px", borderRadius: "5px"}}
               name="message"
               id="message" 
               required="required" 
               data-error="Please, leave us a message."/>

            <p className="success" id="success" style={{color:"green"}}></p>
            <p className="error" id="error" style={{color:"red"}}></p>
            <button  id="button" className="button button-primary button-wide-mobile button-sm" onClick={submitButton} >Submit</button>

              </div>

            </div>

          </div>
        </div>
      </div>
    </section>
  );
}

ContactForm.propTypes = propTypes;
ContactForm.defaultProps = defaultProps;

export default ContactForm;